import * as React from "react";
import { useId } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLightbulb = (props) => {
	const __svgrId = useId();
	return /* @__PURE__ */ _jsx("svg", {
		fill: "none",
		viewBox: "0 0 32 32",
		xmlns: "http://www.w3.org/2000/svg",
		...props,
		children: /* @__PURE__ */ _jsxs("g", {
			transform: "translate(0.4923 0) scale(0.9846)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M13.6105 21.5811 L13.6105 24.3908 C13.6105 25.7163 14.685 26.7908 16.0105 26.7908 C17.336 26.7908 18.4105 25.7163 18.4105 24.3908 L18.4105 21.5811 M16.0105 2.7908 L16.0105 3.9908 M5.2105 14.7908 L4.0105 14.7908 M8.2105 6.9908 L7.4904 6.2707 M23.8105 6.9908 L24.5308 6.2707 M28.0105 14.7908 L26.8105 14.7908 M23.2105 14.7908 C23.2105 18.7673 19.987 21.9908 16.0105 21.9908 C12.0341 21.9908 8.8105 18.7673 8.8105 14.7908 C8.8105 10.8144 12.0341 7.5908 16.0105 7.5908 C19.987 7.5908 23.2105 10.8144 23.2105 14.7908 Z",
					stroke: "white",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					strokeWidth: 5.5
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M18.0105 21.7908 L14.0105 21.7908 L14.0105 26.2908 L18.0105 26.2908 L18.0105 21.7908 Z",
					style: { fill: "var(--sticker-accent,#FBC852)" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M16.0105 21.9908 C19.987 21.9908 23.2105 18.7673 23.2105 14.7908 C23.2105 10.8144 19.987 7.5908 16.0105 7.5908 C12.0341 7.5908 8.8105 10.8144 8.8105 14.7908 C8.8105 18.7673 12.0341 21.9908 16.0105 21.9908 Z",
					style: { fill: "var(--sticker-pastel,#FFE29A)" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M13.6105 21.5811 L13.6105 24.3908 C13.6105 25.7163 14.685 26.7908 16.0105 26.7908 C17.336 26.7908 18.4105 25.7163 18.4105 24.3908 L18.4105 21.5811 M16.0105 2.7908 L16.0105 3.9908 M5.2105 14.7908 L4.0105 14.7908 M8.2105 6.9908 L7.4904 6.2707 M23.8105 6.9908 L24.5308 6.2707 M28.0105 14.7908 L26.8105 14.7908 M23.2105 14.7908 C23.2105 18.7673 19.987 21.9908 16.0105 21.9908 C12.0341 21.9908 8.8105 18.7673 8.8105 14.7908 C8.8105 10.8144 12.0341 7.5908 16.0105 7.5908 C19.987 7.5908 23.2105 10.8144 23.2105 14.7908 Z",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					strokeWidth: 1.5,
					style: { stroke: "var(--sticker-dark,#B87C1F)" }
				})
			]
		})
	});
};
export default SvgLightbulb;
